// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__aC2jL","date":"CreditCardExpiryDate_date__YRRag","expirationYear":"CreditCardExpiryDate_expirationYear__fnc4b"};